import type { HowRelayWorksStage } from "./types";

export const deliverItStage: HowRelayWorksStage = {
  slug: "deliver-it",
  number: 7,
  name: "Deliver it",
  who: "human",
  whoLabel: "You",
  oneLiner: "Put the finished work to use: your project's next step, done by a person.",
  whatItIs:
    "Finished work waits for you as a pull request. Delivering it is your project's own next step, and a person always does it. For Relay itself that's merging and deploying; for an app it might be merging and publishing a release. AI partners never merge, deploy or release.",
  youDo: [
    "On the Sprint Board or in Actions, finished tracks show \"Built · waiting for you\". Open the PR link on the card.",
    "Check that the review approved it and that the required checks are green.",
    "Each track's pull request carries a Relay review check on GitHub. It turns green only when a different AI partner approved the exact commit you'd merge (or Relay carried that approval over). Once your repo requires it, GitHub won't let anyone merge a track PR that isn't approved.",
    "Do your project's step (for Relay, merge and deploy; for an app, merge and publish a release).",
    "If the pull request's own changes are unchanged after main is merged in or it is rebased, the approval carries over and the card says so. Any change to the pull request's own changes, including a conflict fix, needs a new review.",
    "Press Mark on the card to record it as Delivered, or Mark all built for the sprint.",
    "An investigation has nothing to merge. Its card says Findings ready for your review; read the findings, then click Mark reviewed.",
    "If a track was built but not reviewed, Close Sprint warns you first.",
  ],
  aiDoes: [
    "Nothing at this step. It never merges, deploys or releases.",
    "Its review, and any notes to know, are in the Log, linked from the card.",
  ],
  ifWrong:
    "If GitHub says the branch has conflicts, ask an AI partner to update it rather than resolving it in the browser. Then check the result again before delivering. If you marked a card by mistake, say so in the Log. If built work won't be delivered (for example the plan changed), use Won't deliver on its card and give a reason.",
  note: "Merge between sprints so finished work doesn't pile up and conflict. Delivering happens outside Relay, in GitHub and your own tools.",
  goThere: "Open Sprint Board →",
};
